
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
:host {
  display: block;
}
:host div, :host div:focus, :host div:visited {
  outline: none;
}
:host .collapsible-area-wrapper {
  display: flex;
  flex-direction: column;
  padding-top: 16px;
  padding-bottom: 16px;
  font-family: var(--slh-default-font-family, "Open Sans");
  z-index: 10;
}
:host .collapsible-area-wrapper.expanded .collapsible-area-content {
  max-height: 1000000px;
  transform: scaleY(1);
}
:host .collapsible-area-wrapper .collapsible-area-content {
  transform: scaleY(0);
  max-height: 0;
}
:host .collapsible-area-wrapper .collapsible-area-title {
  cursor: pointer;
}
:host .collapsible-area-wrapper .collapsible-area-title:focus {
  outline: 0px;
}
:host .collapsible-area-wrapper .collapsible-area-title .title-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
:host .collapsible-area-wrapper .collapsible-area-title .title-wrapper .icon-wrapper {
  fill: var(--slh-color-neutral-shade-60, #62779F);
}
:host .collapsible-area-wrapper .collapsible-area-title .title-wrapper slot[name=title] {
  display: block;
}
:host .collapsible-area-wrapper .collapsible-area-title .title-wrapper slot::slotted(*) {
  font-size: var(--slh-base-l-font-size, 18px) !important;
  font-weight: var(--slh-base-bold-font-weight, 700) !important;
  line-height: var(--slh-base-xxs-line-height, 24px) !important;
  margin: 0 !important;
  color: var(--slh-color-neutral, #39455D) !important;
}
:host .collapsible-area-wrapper:not(.contained) .collapsible-area-title .title-wrapper {
  padding-bottom: 16px;
  box-shadow: 0px 1px 0px var(--slh-color-neutral-shade-20, #EBEEF4);
}
:host .collapsible-area-wrapper:not(.contained) .collapsible-area-content {
  padding-top: 24px;
}
:host .collapsible-area-wrapper:not(.contained):not(.expanded) {
  padding-bottom: 0;
}
:host .collapsible-area-wrapper:not(.contained):not(.expanded) .collapsible-area-content {
  padding-top: 0;
}
:host .collapsible-area-wrapper.contained {
  background: var(--slh-color-neutral-shade-00, #FFFFFF);
  padding-left: 24px;
  padding-right: 24px;
  border-radius: 4px;
}
:host .collapsible-area-wrapper.contained .title-wrapper {
  box-shadow: none;
  padding-top: 0;
  padding-bottom: 0;
}
:host .collapsible-area-wrapper.contained .title-wrapper slot::slotted(*) {
  font-size: var(--slh-base-m-font-size, 16px) !important;
}
:host .collapsible-area-wrapper.contained.expanded .collapsible-area-content {
  padding-top: 32px;
  padding-bottom: 8px;
}
@media only screen and (max-width: calc(560px - 1px)) {
  :host .collapsible-area-wrapper:not(.contained) {
    background: var(--slh-color-neutral-shade-00, #FFFFFF);
    border-radius: 4px;
    overflow: hidden;
    padding-left: 24px;
    padding-right: 24px;
  }
  :host .collapsible-area-wrapper:not(.contained) .collapsible-area-title .title-wrapper {
    padding-bottom: 16px;
  }
  :host .collapsible-area-wrapper:not(.contained) .collapsible-area-title slot::slotted(*) {
    font-size: 15px !important;
  }
  :host .collapsible-area-wrapper:not(.contained).expanded .collapsible-area-content {
    padding-top: 16px;
  }
  :host .collapsible-area-wrapper.contained .collapsible-area-title slot::slotted(*) {
    font-size: 15px !important;
  }
}

:host .collapsible-area-wrapper .collapsible-area-title:focus-visible:after {
  content: "";
  display: block;
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  position: absolute;
  top: -4px;
  left: -4px;
  border: 2px solid var(--slh-color-outline, #4C49D4);
  border-radius: 4px;
}
`;
